import { useState } from "react";
import { HGHighlightText } from "../../../App/App";
import styles from "./index.module.scss";
import MspReportTable from "./report-table";
import { CustomDeleteModal } from "../../../DeleteModal/DeleteModal";
import { useEntity } from "../../../../hooks/use-entity.hook";
import { Flaggers } from "../../../../common/store/flaggers/flaggers.enum";
import { FlaggersMethods } from "../../../../common/store/flaggers/flaggers.methods";
import useActions from "../../../../hooks/service-actions.hook";
import { PortlandReportEffectActions } from "../../../../common/services/portland-report/portland-report.service";

const SecStackReportList = ({ list = [], setSelectedMSP = () => { }, onReportAdd = () => { }, onReportViewClick = (id, reportId) => { }, searchValue = '', removeReportFromList = () => { } }) => {
  const { 
    setEntityData: setRemovePortlandReportFlagger, 
    entityData: removeModalData 
  } = useEntity({ entityType: Flaggers.RemovePortlandReportFlagger });
  const { removePortlandReport } = useActions(PortlandReportEffectActions);
  
  return (
    <div className={styles.secStackMspListContainer}>
      <div id="sec-stack-msp-list" className={styles.secStackMspList}>
        {list?.map((mspItem) => (
          <MSPItem item={mspItem} onReportAdd={onReportAdd} onReportViewClick={(id, reportId) => { onReportViewClick(id, reportId) }} searchValue={searchValue} />
        ))}
      </div>
      <CustomDeleteModal
        show={removeModalData?.show}
        isLoading={removeModalData?.isLoading}
        deleteHeaderText="Are you sure you want to remove this report?"
        deleteButtonText="Remove"
        hideModal={()=>{
          setRemovePortlandReportFlagger(null, FlaggersMethods.UpdateFlagger);
        }}
        deleteFunction={async ()=>{
          removePortlandReport({ reportId: removeModalData?.reportId, callBack: removeReportFromList });
        }}
      />
    </div>
  )
}

export default SecStackReportList;

const MSPItem = ({ item, onReportAdd = () => { }, onReportViewClick = () => { }, searchValue = '' }) => {
  const [opened, setOpened] = useState([]);

  function ToggleAccordion(e, work = true, id) {
    if (!work) return;
    var parent = e.target.closest(".point-row");
    var panel = parent.querySelector(".panel");

    setOpened((prev) => prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]);

    if (panel?.style?.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 16 + "px";
    }
  }

  return (
    <div className={`${styles.secStackMspListItem} ${opened?.includes(item?.MSPId) ? styles.rowSelected : ''} point-row`}
      style={{ paddingBottom: opened?.includes(item?.MSPId) ? '16px' : '0px' }}
    >
      <MSPItemHeader
        name={item?.MSPName}
        search={searchValue}
        icon={item?.MSPLogo}
        isOpen={opened?.includes(item?.MSPId)}
        onClick={(e) => { ToggleAccordion(e, true, item?.MSPId) }}
      />
      <div className="panel">
        <div className={styles.panelContent}>
          <MspReportTable tableData={item?.MSPSecurityStack_List} mspId={item?.MSPId} onReportAdd={onReportAdd} onReportViewClick={onReportViewClick} />
        </div>
      </div>
    </div>
  )
}


const MSPItemHeader = ({
  name = '',
  icon,
  search = '',
  isOpen,
  onClick = (e) => { }
}) => (
  <div className={`${styles.mspItemHeader} bg-hover-grey`} onClick={(e) => { onClick(e); }}>
    <img src={"/images/chevron-down.svg"} width={11} alt="chevron" className="" style={{ ...(isOpen ? { transform: "rotate(180deg)" } : {}) }} />
    <UserLogo icon={icon} passedClassName={styles.mspLogo} size={32} />
    <span dangerouslySetInnerHTML={{ __html: HGHighlightText(name, search) }} />
  </div>
)

const UserLogo = ({ icon, passedClassName, size }) => (
  <img
    alt="company logo"
    className={passedClassName}
    width={size ?? 32} height={size ?? 32}
    src={(icon && icon !== '') ? icon : '/images/user-logo.svg'}
    style={{ background: (icon && icon !== '') ? '' : '#3D42DE' }}
  />
)